import Backbone from 'backbone'
import ApiToken from './api-token'

/**
 * Collection of ApiToken models
 */
const ApiTokens = Backbone.Collection.extend({
	model: ApiToken
})

export default ApiTokens

ApiTokens.__filename__ = 'admin/api-tokens/api-tokens.js'
